import React from "react"
import {
  BodySubtextMedium,
  BodySubtextMiniMedium,
  BodyTextMedium,
} from "./typography/text"

export const IconWrapper = ({
  children,
  size = "large",
}: {
  children: React.ReactNode
  size?: "large" | "medium" | "small"
}) => {
  const TextComponent =
    size === "large"
      ? BodyTextMedium
      : size === "medium"
        ? BodySubtextMedium
        : BodySubtextMiniMedium

  return (
    <div className="flex items-center justify-center w-4 h-4 min-w-4 min-h-4">
      <TextComponent lineHeight="11px">{children}</TextComponent>
    </div>
  )
}
